import { useBaseProps } from '@hoc/withBaseProps';
import * as React from 'react';
import S from './SectionWrapper.styles';
const SectionWrapper = React.forwardRef((props, ref) => {
    const { children, layout = 'default', flush = 'none', ...otherProps } = props;
    const baseProps = useBaseProps();
    return (React.createElement(S.Container, { ref: ref, id: baseProps.id, "data-allow-scroll-margin": !!baseProps.id, "data-flush": flush, "data-padding-thickness": props.paddingThickness ? props.paddingThickness : 'large', ...otherProps },
        React.createElement(S.Inner, null, renderLayout())));
    function renderLayout() {
        if (layout === 'fullWidth') {
            return children;
        }
        return React.createElement(S.SiteWide, null, children);
    }
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
